export const RANGE_OPTIONS = ["Today", "7D", "30D", "QTD"];

export const QUICK_RANGE_OPTIONS = [
  "Today",
  "Yesterday",
  "This week",
  "Last week",
  "This month",
  "Last month",
  "This year",
  "Last year",
  "All time",
];

export const CHART_COLORS = [
  "#7E50EA",
  "#3B82F6",
  "#F59E0B",
  "#EC4899",
  "#14B8A6",
  "#EF4444",
  "#8B5CF6",
];
